import type { EmailCopyActivationViewDto } from '@/api/asset'
import type { EmailSendRuleDto } from '@/types/touchPoint'
import { formatEmailRule } from '@/utils/emailRuleFormatter'
import { formatNextSend } from '@/utils/emailActivationVersion'
import { parseServerDate } from '@/utils/time'

/**
 * The email activations a sign-off or a reopen reaches (ORB-303), each with what it has waiting: the emails already
 * created and when the next is due, or, for one that sends on an event, the event it sends on.
 */
export function EmailCopyActivationList({ activations }: { activations: EmailCopyActivationViewDto[] }) {
    return (
        <ul className="space-y-1.5">
            {activations.map(activation => (
                <li key={activation.TouchPointId} className="text-sm text-slate-900 dark:text-slate-100">
                    {activation.Name}
                    <span className="text-slate-500 dark:text-slate-400"> · {describeWhatIsWaiting(activation)}</span>
                </li>
            ))}
        </ul>
    )
}

function describeWhatIsWaiting(activation: EmailCopyActivationViewDto): string {
    if (activation.ScheduledEmailCount > 0) {
        const count = `${activation.ScheduledEmailCount.toLocaleString()} ${activation.ScheduledEmailCount === 1 ? 'email' : 'emails'}`
        const next = parseServerDate(activation.NextSendAtUtc)
        // No next send among emails that are waiting means a paused broadcast parked them all.
        return next ? `${count} · next ${formatNextSend(next)}` : `${count} · paused`
    }
    // The generated Rule leaves its enum fields as strings; they carry the same values the editor's rule does.
    return formatEmailRule(activation.Rule as EmailSendRuleDto)
}
